import { Link } from "react-router-dom";
import BlogPostLayout from "./BlogPostLayout";
import { getPostBySlug } from "../../lib/blog";

export default function FrelonsAsiatiques() {
  const post = getPostBySlug("frelons-asiatiques-creuse-que-faire");
  return (
    <BlogPostLayout post={post}>
      <p>
        Depuis quelques années, le <strong>frelon asiatique (Vespa velutina)</strong>{" "}
        est devenu un véritable fléau dans le département de la Creuse. Ses nids,
        souvent installés en hauteur dans les arbres ou sous les toitures,
        représentent un danger réel pour la population, les pollinisateurs et
        l'équilibre des ruchers locaux. Voici comment réagir si vous découvrez un
        nid près de chez vous.
      </p>

      <h2>Comment reconnaître un frelon asiatique ?</h2>
      <p>
        À la différence du frelon européen, jaune et noir, le frelon asiatique
        est plus petit (2,5 à 3 cm) et presque entièrement <strong>noir</strong>{" "}
        avec une large bande orangée sur l'abdomen et le bout des pattes jaune.
        Son vol est rapide, souvent en vol stationnaire devant les ruches qu'il
        attaque pour capturer les abeilles.
      </p>
      <ul>
        <li>Corps majoritairement noir velouté</li>
        <li>Une seule bande orange en bas de l'abdomen</li>
        <li>Extrémité des pattes jaune vif</li>
        <li>Activité diurne (le frelon européen vole aussi la nuit)</li>
      </ul>

      <h2>Où trouve-t-on les nids en Creuse ?</h2>
      <p>
        Au printemps, la fondatrice crée un <strong>nid primaire</strong> de la
        taille d'une orange, généralement abrité (cabanon, sous une avancée de
        toit, garage). Dès la fin du printemps, la colonie migre vers un{" "}
        <strong>nid secondaire</strong>, souvent perché à plus de 10 mètres dans
        un grand arbre. C'est à ce moment qu'on commence à l'apercevoir,
        notamment à l'automne quand les feuilles tombent.
      </p>

      <div className="callout-warn">
        <strong>Ne tentez jamais de détruire un nid vous-même</strong>
        Une simple vibration peut déclencher une attaque collective. Les piqûres
        de frelons asiatiques peuvent provoquer des chocs anaphylactiques et,
        dans les cas les plus graves, le décès. Restez à au moins 5 mètres et
        contactez un professionnel équipé.
      </div>

      <h2>Que faire si je trouve un nid ?</h2>
      <ol>
        <li>
          <strong>Sécurisez la zone</strong> : éloignez les enfants, animaux et
          fermez les fenêtres proches.
        </li>
        <li>
          <strong>Prenez une photo à distance</strong> (zoom) — utile pour le
          diagnostic.
        </li>
        <li>
          <strong>Signalez le nid</strong> à la mairie (qui peut prendre en
          charge une partie du coût dans certaines communes de la Creuse).
        </li>
        <li>
          <strong>Appelez un professionnel équipé</strong> qui interviendra avec
          combinaison intégrale, perche télescopique et produits homologués.
        </li>
      </ol>

      <h2>Combien coûte une destruction de nid en Creuse ?</h2>
      <p>
        Le tarif dépend de la <strong>hauteur</strong> et de l'
        <strong>accessibilité</strong> du nid. En Creuse, comptez généralement
        entre <strong>80 € et 250 €</strong> pour un nid bas, et jusqu'à{" "}
        <strong>350–400 €</strong> pour un nid situé à plus de 15 mètres
        nécessitant un matériel spécifique. Certaines mairies (Guéret, Aubusson,
        La Souterraine…) participent financièrement — renseignez-vous avant
        l'intervention.
      </p>

      <h2>Pourquoi intervenir rapidement ?</h2>
      <p>
        Un nid laissé en place jusqu'à l'automne libère{" "}
        <strong>plusieurs centaines de fondatrices</strong> qui hiverneront et
        formeront de nouveaux nids l'année suivante. Plus tôt l'intervention,
        moins la propagation est rapide. C'est aussi une question de protection
        des <strong>abeilles domestiques</strong>, ressource vitale pour notre
        agriculture creusoise.
      </p>

      <div className="callout">
        <strong>Notre conseil</strong>
        Si vous repérez un nid, n'attendez pas qu'il grossisse. Plus
        l'intervention est précoce (mai-juin), plus elle est simple, rapide et
        économique. Notre équipe intervient en Creuse en{" "}
        <strong>moins de 48h en moyenne</strong>, et même en urgence selon la
        situation.
      </div>

      <h2>Pour aller plus loin</h2>
      <p>
        Découvrez notre page dédiée à la{" "}
        <Link to="/destruction-frelons-creuse">destruction de nids en Creuse</Link>{" "}
        ou consultez les zones d'intervention sur{" "}
        <Link to="/paysagiste-gueret">Guéret</Link>,{" "}
        <Link to="/paysagiste-aubusson">Aubusson</Link> ou{" "}
        <Link to="/paysagiste-la-souterraine">La Souterraine</Link>.
      </p>
    </BlogPostLayout>
  );
}
